<template>
  <div class="description">
    <div >
      <div class="showNumber" >
        <span class="numberText">每行显示数量: </span>
        <a-radio-group v-model="radio">
          <a-radio :value="1">1</a-radio>
          <a-radio :value="3">3</a-radio>
          <a-radio :value="5">5</a-radio>
        </a-radio-group>
      </div>
      <div class="contents" >
        <div class="imgList" v-viewer>
          <ul >
            <li v-for="(item,index) in imgList.smsFile" :key="`instructPic_${index}`" :class="{'one-pic':radio===1,'three-pic':radio===3,'five-pic':radio===5}" >
              <a href="javascript:;">
                <img  v-lazy="item.filePath" :key="`img${index}`" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div v-else>暂无数据</div> -->
  </div>
</template>

<script>
export default {
  props: {
    fileList: Object
  },
  data() {
    return {
      radio: 1,
      imgList: {}
    }
  },
  watch: {
    fileList: {
      handler(val) {
        if (val) {
          this.imgList = val
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
